export enum MessageType {
    SUCCESS,
    ERROR,
    INFO,
    WARNING,
    REVERSAL,
    ADA,
    ARC,
    DEPOSITCURFEW,
    PLVERIFICATION,
    PLAYBREAK,
}
